export function getRGBFromHex(color: string) {
  const hex = color.replace("#", "").trim();
  let blue = 255,
    green = 255,
    red = 255;

  if (hex.length == 6) {
    red = parseInt(hex.substring(0, 2), 16);
    green = parseInt(hex.substring(2, 4), 16);
    blue = parseInt(hex.substring(4, 6), 16);
  }

  if (hex.length == 3) {
    red = parseInt(hex[0] + hex[0], 16);
    green = parseInt(hex[1] + hex[1], 16);
    blue = parseInt(hex[2] + hex[2], 16);
  }

  return { red, green, blue };
}
